export class OverrideNoteDetail {
    constructor(candidateId) {
        this.candidateId = candidateId;
        this.firstName;
        this.lastName;
        this.recruiterEmail;
        this.overrideNote;
    }
}
//# sourceMappingURL=overrideNoteDetail.js.map